
import VoucherItem from '@/components/voucher/voucher-list-item.vue'
import { ref, inject } from 'vue'
import { Toast } from 'vant'
export default {
    components: {
        VoucherItem
    },
    props:{
        voucher_show: {
            type: Boolean,
            defined() {
                return false;
            }
        },
        voucher_type: {
            type: String,
            define() {
                return 'Voucher'
            }
        },
        voucher_list: {
            type: Array,
            required: true
        },
        voucher_code: {
            type: String,
            define() {
                return ''
            }
        },
        amount: {
            type: Number,
            defune() {
                return 0
            }
        },
        goods_discount: {
            type: Number,
            defune() {
                return 0
            }
        }
    },
    setup(props: any, { emit }: any){
        const $http: any = inject('$http')
        let vouchers = ref(props.voucher_list)
        const voucher_btn_fn = () => {
            emit("callback", 1, vouchers.value)
        }
        // Apply code 
        const  apply_code_fn = async () => {
            if(!props.voucher_code){
                Toast.fail('Please enter the voucher code！');
                return false;
            }

            let paream = {
                voucher_code: props.voucher_code,
                amount: parseFloat(props.amount) + parseFloat(props.goods_discount)
            }
    
            let ret = await $http.post_vouchercode_check(paream)
            if(ret.code === 200){
                let voucher_code_obj = {
                    voucher_price: ret.data.voucher_price,
                    voucher_code_val: props.voucher_code,    
                }
                vouchers.value.forEach((item: any) => {
                  item.is_checked = false;
                });
                emit("callback" , 2 , voucher_code_obj)
                //埋点
                // this.$sa_quick_diy('promoteCodeApply',{ 
                //     statusOperation: 'pass',
                // }) 
            }else{
                Toast.fail(ret.message);
                props.qrd_code_val = ''
                //埋点
                // this.$sa_quick_diy('promoteCodeApply',{ 
                //     tipContent: ret.message,
                // }) 
            }
        };
        /**
         * 点击优惠tabs栏
         */
        const tab_click_fn = (name: any, title: any) => {
            if(title === 'close') {
                emit('hide_voucher_show')
            }
        };

        const checkbox_fn = (is_check: any, index: any) => {
          vouchers.value[index].is_checked = is_check
        };
        return {
            voucher_btn_fn,
            apply_code_fn,
            tab_click_fn,
            checkbox_fn,
            vouchers
        }
    }
}
